import { Component, OnInit, inject } from '@angular/core';
import {Router} from '@angular/router';
import {ThuisverzorgerService} from '../../../thuisverzorger/thuisverzorger.service';
import {Thuisverzorger} from '../../../thuisverzorger/thuisverzorger';
import {Observable} from 'rxjs';
import {Zone} from 'src/app/zone/zone';
import {ZoneService} from '../../../zone/zone.service';
import {DienstService} from '../../../dienst/dienst.service';
import {Diensten} from '../../../dienst/diensten';

@Component({
    templateUrl: './add-thuisverzorger.page.html',
    styleUrls: ['./add-thuisverzorger.page.scss'],
    standalone: false
})
export class AddThuisverzorgerPage implements OnInit {
  private thuisverzorgerService = inject(ThuisverzorgerService);
  private zoneService = inject(ZoneService);
  private dienstService = inject(DienstService);
  private router = inject(Router);

  zones$: Observable<Array<Zone>>;
  diensten$: Observable<Diensten>;

  private requestBusy = false;

  ngOnInit(): void {
    this.zones$ = this.zoneService.getZones$();
    this.diensten$ = this.dienstService.getDiensten$();
  }

  onCancelClicked(): void {
    this.navigateToThuisverzorgers();
  }

  onAddClicked(thuisverzorger: Thuisverzorger): void {
    if (!this.requestBusy) {
      this.requestBusy = true;
      this.thuisverzorgerService.postThuisverzorger$(thuisverzorger)
        .subscribe(
          () => this.navigateToThuisverzorgers(),
          () => this.requestBusy = false,
          () => this.requestBusy = false,
        );
    }
  }

  private navigateToThuisverzorgers(): void {
    this.router.navigateByUrl('/thuisverzorgers');
  }

  onEditDienstenClicked() {
    //this.router.navigateByUrl(`/thuisverzorgers/${.getId()}/diensten/beheer`);
  }
}
